// priceRules.js

const priceRules = [
    {
      id: "test",
      formula: "((doorData.frameData.sideLiteSize * doorData.frameData.frameHeight)/144) * <<price1>>",
      price1: ["ref_sideLiteGlass", "doorData.sideLite.sideLiteOptionsS_label"],
      price2: ["Gentek", "doorData.frameData.frameColor"],
      unitPrice: 7,
      multiplicator: {
        condition: "doorData.frameData.selectedDoor?.id === 4 || doorData.frameData.selectedDoor?.id === 8",
        value: 2
      }
    },
    { id: "ref_sideLiteGlass", Clear: 1, Sandblasted: 2, Delta: 3 },
    { id: `ref_doorGlass`, Clear: 0.2, Sandblasted: 0.4, Delta: 0.8 },

    { id: `ref_magnetLatch`, Yes: 10, No: 0 },
    {
      id: "magnetLatch",
      formula: "<<price1>>",
      price1: [`ref_magnetLatch`, "doorData.frameData.magnetLatch"],
      unitPrice: 1,
      minValue: null
    },
    { id: `ref_subFrame`, Yes: 100, No: 0 },
    {
      id: "subFrame",
      formula: "<<price1>>",
      price1: [`ref_subFrame`, "doorData.frameData.subFrame"],
      unitPrice: 1,
      minValue: null
    },   

    {
      id: "frameSize",
      formula: "((doorData.frameData.frameWidth * doorData.frameData.frameHeight)/144)",
      //formula: "Number(doorData.frameData.frameWidth)",
      //price1: [`ref_doorGlass`, "Clear"],
      unitPrice: 100,
      minValue: 1
    },

    { id: `ref_measurementType`, 'Screen Size': 20, 'Sub Frame(Box profie 3/4"x1 1/2")': 30 },
    {
      id: "measurementType",
      formula: "<<price1>>",
      price1: [`ref_measurementType`, "doorData.frameData.measurementType"],
      unitPrice: 1,
      minValue: 0
    },
    { id: `ref_screenFrameColor`, 'White': 20, 'Gentek': 30 },   
    {
      id: "screenFrameColor",
      formula: "<<price1>>",
      price1: [`ref_screenFrameColor`, "doorData.frameData.screenFrameColor"],
      unitPrice: 1,
      minValue: 1
    }, 
    {
      id: "screenFrameColorGentek",
      formula: "<<price1>>",
      price1: [`ref_screenFrameColor`, "doorData.frameData.screenFrameColor"],
      unitPrice: 1,
      minValue: 1
    }, 
    { id: `ref_CascadingCombo`, 'Key Lock for Tilt and Turn': 20, A: 30, B: 40, C: 50 },
    {
      id: "CascadingCombo1",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo1"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo2",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo2"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo3",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo3"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo4",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo4"],
      unitPrice: 1,
      minValue: 0
    },
    {
      id: "CascadingCombo5",
      formula: "<<price1>>",
      price1: [`ref_CascadingCombo`, "doorData.additionalItems.CascadingCombo5"],
      unitPrice: 1,
      minValue: 0
    }

  ];
  
  export default priceRules;
  